import { render, staticRenderFns } from "./MamaFindingForm.vue?vue&type=template&id=972a2a9c&"
import script from "./MamaFindingForm.vue?vue&type=script&lang=js&"
export * from "./MamaFindingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports